const en_translations = {
    map: 'Map',
    no_results : 'No results',
    deposit: 'Deposit',
    search_address: 'Search an address',
    search_pointcash: 'Search an address',
    day: "Day",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    schedules: "Schedules",
    schedules_information_only: "Schedules are for information only",
    best_navigation: "Click below for the fastest route to the selected point of sale.",
    route: 'Route',
    map_loading: 'Loading points of sale ...',
    no_geoloc: 'In order to find the closest stores to your location, please enter an address in the address bar above.',
    remove_route: 'Remove route',
    maintenance: 'Maintenance',
    site_unavailable: 'Site unavailable',
    site_unavailable_text: 'The site is temporarily unavailable due to maintenance activities. You can try to sign in again in a few minutes.',
    thanks_understanding: 'Thank you for your understanding.',
    page_not_found: 'Page not found',
    page_not_found_text: 'We\'re sorry, but the page you requested does not exist. If you believe this is an error, please contact your administrator.',
    no_opening_hours: 'Opening hours not available',
    error_occured_while_loading_app : "An error occured while loading the application.",
    error_occured_while_loading_pos : "An error occured while loading the points of sale.",
}

export default en_translations;
